<div class="panel-group mb-20">
  <div class="panel panel-default">
    <!-- <div class="panel-heading">
      <h2 class="panel-title col-sm-11">
        <a (click) = "changeStatusPanel()" data-toggle="collapse"> {{labelTitle ? labelTitle : 'Ricerca persona'}} <span *ngIf="required" class="mandatory ">*</span></a>
      </h2>
      <a (click) = "changeStatusPanel()" data-toggle="collapse" aria-expanded="openPanel" >
        <span *ngIf="!openPanel" class="glyphicon glyphicon-triangle-bottom" ></span>
        <span *ngIf="openPanel" class="glyphicon glyphicon-triangle-top" ></span>
      </a>
    </div> -->

    <div class="panel-heading">
      <div class="row">
        <h2 class="panel-title col-xs-10">
          <a (click) = "changeStatusPanel()" data-toggle="collapse"> 
            {{labelTitle ? labelTitle : 'Ricerca persona'}} 
            <span *ngIf="required" class="mandatory ">*</span>
          </a>
        </h2>
        <div class="col-xs-2">
          <a (click)= "changeStatusPanel()" data-toggle="collapse" aria-expanded="openPanel" >
            <span *ngIf="!openPanel" class="glyphicon glyphicon-triangle-bottom" ></span>
            <span *ngIf="openPanel" class="glyphicon glyphicon-triangle-top" ></span>
          </a>
        </div>
      </div>
    </div>

    <div   id="collapse1" class="{{openPanel ? 'panel-collapsed collapsed' : 'panel-collapse collapse'}}">

      <div class="panel-body">
        <label for="">Tipo persona</label> <span class="mandatory ">*</span>
        <select class="form-control"  [(ngModel)]="personTypeSelect" style="margin-bottom: 15px;">
          <option [ngValue]="null" >Seleziona tipo di persona</option>
          <option  *ngFor="let person of personType" [ngValue]="person">{{person.name}}</option>
        </select>
        <div *ngIf="personTypeSelect==null" class="row">
          <div class="col-xs-12 col-sm-6"></div>
          <div class="col-xs-6 col-sm-3">
            <button class="btn-secondary btn btn-block" type="button"
              (click)="resetForm()">
              Reset
            </button>
          </div>
          <div class="col-xs-6 col-sm-3">
            <button class="btn-primary btn btn-block" type="button"
              (click)="getAllPersons()">
              Ricerca
            </button>
          </div>
        </div>
        <div *ngIf="personTypeSelect != null">
          <app-dynamic-form *ngIf="personTypeSelect.id === 'PHYSICAL_ENTITY'" [questions]="formFieldsPhysical" [config]="formConfiguration"
          (onFormSubmit)="sendSearch($event,personTypeSelect.id)" (onFormReset)="resetForm()"></app-dynamic-form>
          <app-dynamic-form *ngIf="personTypeSelect.id === 'LEGAL_ENTITY'" [questions]="formFieldsLegal" [config]="formConfiguration"
          (onFormSubmit)="sendSearch($event,personTypeSelect.id)" (onFormReset)="resetForm()"></app-dynamic-form>
        </div>
        </div>
    </div>
  </div>
</div>


<table *ngIf="persons && persons.totalItems > 0 && openPanel" class="table">
  <caption class="sr-only">Tabella persone</caption>
  <thead>
    <tr>
      <th class="col-xs-3">Tipo persona</th>
      <th class="col-xs-3">Nominativo</th>
      <th class="col-xs-3">Codice fiscale / p.iva</th>
      <th class="col-xs-3"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let person of persons.items">

      <td class="col-xs-3 cell">{{person.type === 'PHYSICAL_ENTITY' ? 'PERSONA FISICA' : 'PERSONA GIURIDICA'}}</td>
      <td *ngIf="person.type === 'PHYSICAL_ENTITY'" class="col-xs-3 cell">{{person.lastName}} {{person.firstName}} </td>
      <td *ngIf="person.type === 'LEGAL_ENTITY'" class="col-xs-3 cell">{{person.name}}</td>
      <td class="col-xs-3 cell">{{person.taxNumber}}</td>

      <td class="rightaligned">

        <button type="button" *ngIf="((listPersonID && !disableById(person) || (forbiddenPersons && !checkPerson(person))))" (click)="onSelectPerson(person)" class="btn-link">{{labelButton ? labelButton : 'Seleziona'}}</button>
        <button type="button" *ngIf="((listPersonID && disableById(person) || (forbiddenPersons && checkPerson(person))))" class="btn-link" style="color: red;">Già associato</button>
      </td>
    </tr>
  </tbody>
</table>


<div *ngIf="persons && openPanel" class="card-pagination">
  <app-pagination
    (refreshEvent)="updatePersons($event)"
    [resetCurrentPage]="resetCurrentPage"
    [totalItems]="persons.totalItems">
  </app-pagination>
</div>
